import React, { useRef, useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../../mensajes2";

import {
  validaSoloNumero,
  formatMoneda,
  validaMonto,
  formatoMonto,
} from "../../../util/varios";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import TablaDeudaLicores from "./tablaDeudaLicores";
import TablaHistoricoLicores from "./tablaHistoricoLicores";
import { Dimmer } from "../../spinner";
import TablaMultaLicores from "./tablaMultaLicores";

export const ModalCuentaEstado = (props) => {
  /*  variables de estados */

  let op = require("../../../../src/modulos/datos");

  const btnCancela = useRef();
  const btnAcepta = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [mostrar1, setMostrar1] = useState(false);
  const [titulo2, setTitulo2] = useState();
  const [msg2, setMsg2] = useState();
  const [contar1, setContar1] = useState(0);
  const [activate, setActivate] = useState(false);
  const txtCodigoCiu = useRef();
  const txtIdactividad = useRef();
  const txtAlicuota = useRef();
  const txtDescripcionActi = useRef();
  const txtAnios = useRef();
  const txtMinimo = useRef();
  const txtActualizada = useRef();
  const txtCodActividad = useRef();
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [tabIndex, setTabIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [idUsuario, setIdUsuario] = useState();
  const [declaWeb, setDeclaWeb] = useState();
  const txtIdComercio = useRef();
  const txtRitm = useRef();
  const txtNumPatente = useRef();
  const txtDenominacionCome = useRef();
  const txtDireccionContri = useRef();
  const txtEmailContri = useRef();
  const txtCedula = useRef();
  const cmbStatus = useRef();
  const txtObserStatus = useRef();
  const [status, setStatus] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });

  const styleTabs = {
    borderTop: "1px solid",
    borderColor: "rgba(0, 88, 129, 1)",
    borderLeft: "none",
    borderTopRightRadius: "16px",
  };

  const handleCloseSi = () => {
    setMostrar1(false);
  };

  const handleCloseNo = () => {
    setMostrar1(false);
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const imprimirRelacionPago = () => (event) => {
    event.preventDefault();

    var reporte = "Planillacontricomercio";
    var idrentas = props.inmobiliaria.idrentas;
    /*  window.open(
      op.reportes + "reporte=" + reporte + "&id=" + idrentas + "&tipo=(16)",
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
    ); */

    window.open(
      op.reportes +
        "/inmueblesurbanos?" +
        "reporte=" +
        reporte +
        "&id=" +
        idrentas +
        "&tipo=(16)",
      "Planilla",
      "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
    );
  };

  const salir = () => {
    props.onHideCancela();
  };
  const handlerClickTab = (index, lastIndex, event) => {
    //alert("Tab seleccionado: " + index + " .\ Tab anterior seleccionado: " + lastIndex);
    if (operacion === 1 && (index === 2 || index === 3)) {
      setTabIndex(0);
    } else {
      setTabIndex(index);
    }
  };
  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setTabIndex(0);

        if (props.comercio && props.comercio.status === "51") {
          setStatus("ACTIVO");
        } else if (props.comercio && props.comercio.status !== "51") {
          setStatus("INACTIVO");
        } else {
          setStatus("error");
        }

        setVisible(props.declaWeb == false ? "hidden" : "visible");

        /*  setDeshabilitado(props.deshabilitado);
                 setOperacion(props.operacion);
 
                 setVisible(false);
                 setIdUsuario(props.idusuario);
                 setDeclaWeb(props.declaweb);
                 setTabIndex(0);
                 setContar1(0);
                 
               
  */
      }}
    >
      <Modal.Header className="azulGradiant">
        <Modal.Title style={{ color: "#fff" }}>
          Consultar Estado Cuenta - Licores
        </Modal.Title>
        <button
          ref={btnCancela}
          className="btn"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={salir}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body style={{ color: "rgb(106, 115, 123)" }}>
        {/* <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <MensajeSiNo
          titulo={titulo2}
          mensaje={msg2}
          show={mostrar1}
          onHideSi={handleCloseSi}
          onHideNo={handleCloseNo}
        /> */}
        <Dimmer active={activate}></Dimmer>
        <div className="col-md-12 row mx-auto">
          <div className="row col-md-12 rounded border border-secundary mx-auto">
            <div
              className="container mx-auto"
              style={{ backgroundColor: "", color: "" }}
            >
              <h3>Detalle Deuda Contribuyente Rentas Licores</h3>
              <table className="table table-sm v-100">
                <tbody>
                  <tr>
                    <td>
                      <span className="">Código Contribuyente: &nbsp; </span>
                      <label for="colFormLabelSm" className="form-label">
                        {" "}
                        {props.comercio
                          ? props.comercio.idcomercio !== null
                            ? props.comercio.idcomercio.trim()
                            : ""
                          : ""}
                      </label>
                    </td>
                    <td>
                      <span className=""> N° de RITM: &nbsp; </span>
                      <label for="colFormLabelSm" className="form-label">
                        {props.comercio
                          ? props.comercio.ritm !== null
                            ? props.comercio.ritm.trim()
                            : ""
                          : ""}{" "}
                      </label>
                    </td>
                    <td>
                      <span className=""> Estatus: &nbsp; </span>
                      <label for="colFormLabelSm" className="form-label">
                        {status}
                      </label>
                    </td>

                    <td>
                      <button
                        className="btn btn-sm btn-primary rounded-pill"
                        style={{ visibility: visible }}
                        onClick={imprimirRelacionPago("Planillacontricomercio")}
                      >
                        <i className="fa fa-print"> Relación Pagos Web</i>{" "}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div
              className="container"
              style={{ backgroundColor: "", color: "" }}
            >
              <table className="table table-sm v-100">
                <tbody>
                  <tr>
                    <td>
                      <span className="">
                        {" "}
                        Nombre del Contribuyente: &nbsp;{" "}
                      </span>
                      <label for="colFormLabelSm" className="form-label">
                        {" "}
                        {props.comercio
                          ? props.comercio.nombre !== null
                            ? props.comercio.nombre.trim()
                            : ""
                          : ""}
                      </label>
                    </td>

                    <td>
                      <span className=""> Dirección del inmueble: &nbsp; </span>
                      <label for="colFormLabelSm" className="form-label">
                        {" "}
                        {props.comercio
                          ? props.comercio.direccion !== null
                            ? props.comercio.direccion.trim()
                            : ""
                          : ""}
                      </label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <ul className="nav" id="myTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link active bg-blue-100 text-light"
                id="datosTributarios"
                data-bs-toggle="tab"
                data-bs-target="#tributarios"
                type="button"
                role="tab"
                aria-controls="tributarios"
                aria-selected="true"
              >
                Deudas del Contribuyente
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-200 text-light"
                disabled={
                  operacion === 1 || operacion === 3 ? true : deshabilitado
                }
                id="multa-tab"
                data-bs-toggle="tab"
                data-bs-target="#multa"
                type="button"
                role="tab"
                aria-controls="multa"
                aria-selected="false"
              >
                Deuda Multas
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className="rounded nav-link bg-blue-200 text-light"
                disabled={
                  operacion === 1 || operacion === 3 ? true : deshabilitado
                }
                id="deuda-tab"
                data-bs-toggle="tab"
                data-bs-target="#deuda"
                type="button"
                role="tab"
                aria-controls="deuda"
                aria-selected="false"
              >
                Historicos de Pagos
              </a>
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade show active"
              id="tributarios"
              role="tabpanel"
              aria-labelledby="datosTributarios"
            >
              <TablaDeudaLicores
                comercio={props.comercio}
                petro={props.petro}
                visibleF={"visible"}
                tabDeuda={props.deuda}
                idcomercio={
                  props.comercio
                    ? props.comercio.idcomercio !== null
                      ? props.comercio.idcomercio
                      : ""
                    : ""
                }
              />
            </div>

            <div
              className="tab-pane fade"
              id="deuda"
              role="tabpanel"
              aria-labelledby="deuda-tab"
            >
              <TablaHistoricoLicores tabHis={props.historico} />
            </div>
            <div
              className="tab-pane fade"
              id="multa"
              role="tabpanel"
              aria-labelledby="multa-tab"
            >
              <TablaMultaLicores idComercio={props.comercio?.idcomercio} />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnCancela}
          onClick={salir}
          className="btn btn-sm btn-danger rounded-pill col-md-2"
        >
          <i className="fas fa-window-close"> Salir</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};
